var _path, _path2, _circle, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "aaaaaa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8861 13.4919C13.9216 13.4919 14.7611 12.6525 14.7611 11.6169C14.7611 10.5814 13.9216 9.74194 12.8861 9.74194C11.8506 9.74194 11.0111 10.5814 11.0111 11.6169C11.0111 12.6525 11.8506 13.4919 12.8861 13.4919ZM12.8846 12.7439C13.507 12.7439 14.0116 12.2393 14.0116 11.6169C14.0116 10.9945 13.507 10.49 12.8846 10.49C12.2622 10.49 11.7577 10.9945 11.7577 11.6169C11.7577 12.2393 12.2622 12.7439 12.8846 12.7439Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04114 13.4919C6.07667 13.4919 6.91614 12.6525 6.91614 11.6169C6.91614 10.5814 6.07667 9.74194 5.04114 9.74194C4.0056 9.74194 3.16614 10.5814 3.16614 11.6169C3.16614 12.6525 4.0056 13.4919 5.04114 13.4919ZM5.04285 12.7458C5.66632 12.7458 6.17175 12.2404 6.17175 11.6169C6.17175 10.9935 5.66632 10.488 5.04285 10.488C4.41937 10.488 3.91394 10.9935 3.91394 11.6169C3.91394 12.2404 4.41937 12.7458 5.04285 12.7458Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8861,
    cy: 11.6502,
    r: 0.705892,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.0411,
    cy: 11.6502,
    r: 0.705892,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.937378 8.10432L0.937403 9.82471L1.04225 11.1957C1.0695 11.5521 1.35411 11.8346 1.71072 11.8591L2.90611 11.9414C2.81932 11.1515 3.27637 9.59856 4.99766 9.59856C6.71895 9.59856 7.23179 11.1637 7.16007 11.8347H10.7789C10.6861 11.1188 11.1644 9.63874 12.7946 9.58977C14.4247 9.54079 15.0343 11.0249 14.9551 11.8281H16.3957C16.6931 11.8281 16.9366 11.5918 16.9455 11.2945L16.9989 9.50225C17.0382 8.18448 15.9988 7.08583 14.6809 7.05207L13.0455 7.01018C12.9919 7.00881 12.9421 6.98229 12.9111 6.93862L12.1538 5.87283C11.6148 5.10603 10.7945 4.5835 9.87175 4.41927L8.79148 4.22701L8.58689 4.21418C7.52223 4.1474 6.45433 4.27592 5.43591 4.59338C4.96095 4.74143 4.54422 5.03438 4.24412 5.43117L3.17919 6.83923C3.09251 6.95384 2.96071 7.02562 2.8174 7.03625L1.86337 7.10705C1.34123 7.1458 0.93737 7.58075 0.937378 8.10432ZM12.0583 7.02853L7.44874 7.16767C6.4259 7.10121 4.99721 6.74435 4.80754 6.67799C4.8381 6.62451 4.86874 6.56976 4.89977 6.51433C5.15535 6.05772 5.43686 5.55479 5.90927 5.33194C6.82901 4.89806 8.51083 4.82516 9.93686 5.20325C10.9736 5.47812 11.3926 6.0795 11.8275 6.70361C11.9028 6.81176 11.9787 6.92059 12.0583 7.02853Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2644 7.46785L7.48743 4.71313H8.2655L9.04584 7.46785H8.2644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6e4d1b4c1f1788942a9dc207894d7275.svg";
export { ForwardRef as ReactComponent };